"use strict";

var identity = function identity(x) {
  return x;
};

module.exports = function (key, value, decorator) {
  var o = {};
  o[key] = (decorator || identity)(value);
  return o;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/last-search-cookie/make-object.js
 ** module id = 458
 ** module chunks = 0
 **/